const CenterDCBReportActionTypes = {
	FETCH_CENTER_DCB_REPORT_START: 'fetch_center_dcb_report_start',
	FETCH_CENTER_DCB_REPORT_SUCCESS: 'fetch_center_dcb_report_success',
	FETCH_CENTER_DCB_REPORT_FAILURE: 'fetch_center_dcb_report_failure',
	FETCH_CENTER_DCB_REPORT_RESPONSE_RESET: 'fetch_center_dcb_report_response_reset',
	FETCH_CENTER_DCB_REPORT_RESPONSE_CHANGED: 'fetch_center_dcb_report_response_changed',
};
export default CenterDCBReportActionTypes;
